import React from 'react';
import { Locale } from '../../../../localization/LocalizationKeys';
import LinkBadge from '../../../components/Badge/LinkBandge';
import { linkFieldConfig } from '../../person/fields/utils/personFieldsUtils';

export const linkSitePureAdvanceIdFieldConfig = linkFieldConfig(
  'siteId',
  [
    'id',
    'site.id',
  ],
  ({ localization, openInNewTab }) => ({
    title: localization.formatMessage(Locale.Attribute.Site_PureAdvance_ID),
    additionalTableConfig: {
      width: 120
    },
    render: (record) => <LinkBadge
      url={`/hco/${record.site.id}`}
      label={record.site.id}
      openInNewTab={openInNewTab}
    />,
  })
);
